// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2bnQh","tab":"Tabs_tab__3FV8z","tabActive":"Tabs_tabActive__1aSBt"};